import { colors } from "../../styles";

export default {
    primaryButton: { backgroundColor: colors.blue, borderRadius: 16 }
};
